"use strict";

var FacilityTypeFilter = function () {
  var getFilterFacilityTypeOptions = function (
    facilities = Tree.get("layers", "indcomFacilities", "data"),
  ) {
    const groupFacilityTypes = IndcomInventoryConstants.getFacilityTypeOptions();
    const includedFacilityTypes = [...new Set(facilities.map((facility) => facility.facilityType))];

    return Object.values(groupFacilityTypes)
      .filter((facilityType) => includedFacilityTypes.includes(facilityType.value))
      .map((facility) => {
        return {
          ...facility,
          facilityType: facility.value,
          displayFacilityType: facility.name,
        };
      })
      .sort(function (a, b) {
        const textA = a.displayFacilityType.toUpperCase();
        const textB = b.displayFacilityType.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
  };

  return {
    getFilterFacilityTypeOptions,
  };
};

module.exports = FacilityTypeFilter();

const IndcomInventoryConstants = require("../indcom/indcomInventoryConstants");
const Tree = require("../tree");
